module.exports = __webpack_public_path__ + "img/wholesale-icon.987489a7.svg";